import { DOMElement } from '../utils/DOMElement';
import stepBarConfig from '../../../conf/stepbar.conf';

/**
 * Step bar Component.
 */
export class StepBar {
  /**
   * String of the dom element of the step bar container.
   *
   * @type {string}
   */
  static containerDOMSelector = '#stepbar';

  /**
   * String of the css class of the current step.
   *
   * @type {string}
   */
  static currentStepClass = 'ideal-stepbar-step-container-active';

  /**
   * String of the css class of the done step.
   *
   * @type {string}
   */
  static doneStepClass = 'ideal-stepbar-step-container-complete';

  /**
   * String of the dom element of the current step.
   *
   * @type {string}
   */
  static currentStepDOMSelector = `${StepBar.containerDOMSelector} .ideal-stepbar-step-container.${StepBar.currentStepClass}`;

  /**
   * Render the component.
   *
   * @param {object} opts - The options to render the component.
   */
  static render(opts) {
    const stage = opts && opts.stage;
    const isBack = opts && opts.isBack;

    const step = StepBar.getRelatedStep(stage);

    if (!step) {
      StepBar.hide();

      return;
    }

    StepBar.setCurrent(step, isBack);
    StepBar.show();
  }

  /**
   * Show the step bar in the component.
   */
  static show() {
    const elem = document.querySelector(StepBar.containerDOMSelector);

    if (elem) {
      elem.style.display = 'block';
    }
  }

  /**
   * Hide the step bar in the component.
   */
  static hide() {
    const elem = document.querySelector(StepBar.containerDOMSelector);

    if (elem) {
      elem.style.display = 'none';
    }
  }

  /**
   * Set current step in bar.
   *
   * @param {string} step - The step to set as current.
   * @param {boolean} isBack - Boolean if back button pressed.
   */
  static setCurrent(step, isBack) {
    const elem = document.getElementById(`stepbar-item-${step}`);

    if (elem && elem.className.indexOf(StepBar.currentStepClass) === -1) {
      const navClass = StepBar.doneStepClass;

      StepBar.removeCurrent(isBack);
      DOMElement.removeClass(navClass, elem);
      DOMElement.addClass(StepBar.currentStepClass, elem);

      const line = elem.previousSibling;

      if (line && line.className && line.className.indexOf('ideal-stepbar-line') !== -1) {
        DOMElement.addClass('ideal-stepbar-line-complete', line);
      }
    }
  }

  /**
   * Remove current step class.
   *
   * @param   {boolean} isBack - Boolean if back button pressed.
   */
  static removeCurrent(isBack) {
    const elem = document.querySelector(StepBar.currentStepDOMSelector);

    if (elem) {
      const navClass = StepBar.doneStepClass;

      DOMElement.removeClass(StepBar.currentStepClass, elem);

      const line = elem.previousSibling;

      if (line && line.className && line.className.indexOf('ideal-stepbar-line') !== -1) {
        DOMElement.removeClass('ideal-stepbar-line-complete', line);
      }

      if (!isBack) {
        DOMElement.addClass(navClass, elem);
      }
    }
  }

  /**
   * Delete steb bar.
   */
  static deleteStepBar() {
    const elem = document.querySelector(StepBar.containerDOMSelector);
    if (elem) {
      elem.parentNode.removeChild(elem);
    }
  }

  /**
   * Get the related step to set as current for stage.
   *
   * @param {string} stage - The inserted stage.
   * @returns {string|undefined} - The related step for stage or undefined.
   */
  static getRelatedStep(stage) {
    return stepBarConfig[stage] && stepBarConfig[stage].step;
  }
}
